import instance from './axiosInstance';

function getExistingIntegrations(http = instance) {
  return http.get('/integration/list');
}

function getAvailablePartners(http = instance) {
  return http.get('/integration/partner');
}

function getConfiguration(payload, options = {}, http = instance) {
  return http.get(`/integration/config/${payload.configId}`, options);
}

function verifyConfiguration(reqBody, options = {}, http = instance) {
  return http.post('/integration/verify', reqBody, options);
}

function saveConfiguration(reqBody, options = {}, http = instance) {
  return http.post('/integration/config', reqBody, options);
}

function updateConfigStatus(reqBody, options = {}, http = instance) {
  return http.put(`/integration/config/${reqBody.id}`, reqBody.payload, options);
}

export {
  getExistingIntegrations,
  getAvailablePartners,
  getConfiguration,
  verifyConfiguration,
  saveConfiguration,
  updateConfigStatus,
};
